import { motion } from "motion/react"

interface Props {
    title: string,
    price: string,
    imageUrl: string,
    bedrooms: string,
    bathrooms: string,
    area: string
    location?: string
    desc?: string
    index?: number
    featured: string
    sold: string
}

const PropertyCard = ({ title, price, imageUrl, bedrooms, bathrooms, area, location, sold, featured, desc, index }: Props) => (
    <motion.div
        initial={{ opacity: 0, scale: 0.8, translateY: 200 }}
        whileInView={{ opacity: 1, scale: 1, translateY: 0 }}
        transition={{ duration: 0.7, ease: "easeOut", delay: Number(`0.${index}`) }}
        className="relative bg-white shadow-lg rounded-lg overflow-hidden">
        <img src={(imageUrl)} alt={title} className="w-full h-48 object-cover" />
        <div className="p-6">
            <h3 className="font-semibold text-lg">{title}</h3>
            <p className="mt-2 text-gray-600">{desc?.slice(0, 100)}...</p>
            <p className="mt-2 text-gray-600">₦{price}</p>
            <p className="mt-1 text-gray-500 text-sm">{bedrooms} Beds · {bathrooms} Baths · {area} Sqft</p>
        </div>
        <div className="top-0 absolute flex justify-between p-4 w-full">
            {featured === 'true' && <p className="bg-[#c08b53] mt-2 px-4 pb-1 rounded-lg text-[13px] text-white">Featured</p>}
            <div className="flex gap-2">
                {sold === 'false' && <p className="bg-[#000000d5] mt-2 px-4 pb-1 rounded-lg text-[13px] text-white">For Sale</p>}
                {sold === 'true' && <p className="bg-[#000000d5] mt-2 px-4 pb-1 rounded-lg text-[13px] text-white">Sold</p>}
            </div>
        </div>
    </motion.div>
);

export default PropertyCard;